import { apiClient } from '@/lib/api-client';
import type { Offer } from '@/types/api';

export type OfferInput = {
  patientId: string | null;
  patientName: string;
  steps: string[];
  totalRsd: number;
  note: string | null;
  dentistId?: string | null;
};

export const offersApi = {
  /** Newest first; `q` matches the number or the patient name. */
  async list(q: string, limit = 50) {
    const { data } = await apiClient.get<Offer[]>('/offers', {
      params: { q: q || undefined, limit },
    });
    return data;
  },
  async get(id: string) {
    const { data } = await apiClient.get<Offer>(`/offers/${id}`);
    return data;
  },
  async create(input: OfferInput) {
    const { data } = await apiClient.post<Offer>('/offers', {
      ...input,
      dentistId: input.dentistId ?? undefined,
    });
    return data;
  },
  async update(id: string, input: OfferInput) {
    const { data } = await apiClient.patch<Offer>(`/offers/${id}`, {
      ...input,
      dentistId: input.dentistId ?? undefined,
    });
    return data;
  },
};
